/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { JSX } from "react"

interface DangerZoneCardProps {
    external: boolean
    onRemoveExternalClick: () => void
    onDeleteUserClick: () => void
    onResetPasswordClick: () => void
    onResetTOTPClick: () => void
    onClose: () => void
}

export function DangerZoneCard({
    external,
    onRemoveExternalClick,
    onDeleteUserClick,
    onResetPasswordClick,
    onResetTOTPClick,
    onClose
}: DangerZoneCardProps): JSX.Element {
    return (
        <div className="modal block modal-on-background" tabIndex={-1} role="dialog" onClick={onClose}>
            <div className="modal-dialog modal-dialog-centered" role="document" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal-header bg-legacy-danger text-white">
                        <h5 className="modal-title">Danger Zone</h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
                    </div>
                    <div className="modal-body py-legacy">
                        <p>These actions are irreversible:</p>
                        {external ? (
                            <div className="grid gap-2">
                                <button
                                    className="btn btn-outline-danger"
                                    onClick={() => {
                                        onRemoveExternalClick()
                                        onClose()
                                    }}
                                >
                                    Remove external user
                                </button>
                            </div>
                        ) : (
                            <div className="grid gap-2">
                                <button
                                    className="btn btn-outline-danger"
                                    onClick={() => {
                                        onDeleteUserClick()
                                        onClose()
                                    }}
                                >
                                    Delete User
                                </button>
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={() => {
                                        onResetPasswordClick()
                                        onClose()
                                    }}
                                >
                                    Reset Password
                                </button>
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={() => {
                                        onResetTOTPClick()
                                        onClose()
                                    }}
                                >
                                    Reset TOTP
                                </button>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={onClose}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
